// extracted by mini-css-extract-plugin
export var addButton = "_9m-0";
export var border = "_9m-8";
export var check = "_9m-h";
export var danger = "_9m-6";
export var dropdownContainer = "_9m-1";
export var editModalBody = "_9m-j";
export var footerContainer = "_9m-i";
export var fullWidth = "_9m-a";
export var hide = "_9m-9";
export var icon = "_9m-3";
export var input = "_9m-7";
export var inputFlex = "_9m-b";
export var inputWrapper = "_9m-c";
export var manualFocus = "_9m-5";
export var optionButton = "_9m-4";
export var pillWrapper = "_9m-e";
export var pointer = "_9m-2";
export var showOverflow = "_9m-f";
export var tagsFlex = "_9m-d";
export var xButton = "_9m-g";